import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import validators from './validators/index';
import {ValidatonError} from '../resources/GenericResource';


const ForgotPasswordFormModel = t.struct({
    email: validators.email,
});

function formLayout(locals){
    let renderedInputs = Object.keys(locals.inputs).map(function(key){
        return fieldLayout(locals.inputs[key]);
    });
    return (
        <div>
            {renderedInputs}
        </div>
    );
}

function fieldLayout(field){
    return (
        <label className="form-control form-control-text">
            {field}
        </label>
    );
}

const Form = baseFormFactory(ForgotPasswordFormModel);

class ForgotPasswordForm extends Form {
    constructor(props) {
        super(props);
    }

    getValue() {
        return this.refs.form.getValue();
    }

    getOptions() {
        const loginError = this.props.loginError;

        return {
            auto: 'placeholders',
            hasError: !!loginError,
            template: formLayout,
            fields: {
                email: {
                    hasError: !!loginError,
                    error: (loginError.error && loginError.error.getFieldError && loginError.error.getFieldError('email', true) || null) || (loginError['email'] ? loginError['email'] : null)
                }

            }
        };
    }

    render() {
        return (
            <t.form.Form ref="form" value={this.props.originalFormData} type={ForgotPasswordFormModel} options={this.getOptions()} />
        );
    }
}

ForgotPasswordForm.propTypes = {
    originalFormData: React.PropTypes.object.isRequired,
    loginError: React.PropTypes.instanceOf(ValidatonError)
};

export default ForgotPasswordForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/ForgotPasswordForm.js
 **/